module.exports = __webpack_public_path__ + "img/button-key.c8572f17.svg";